import { render, staticRenderFns } from "./ArticleRelatedHeadlinesList.vue?vue&type=template&id=06e2ba25&scoped=true&"
import script from "./ArticleRelatedHeadlinesList.vue?vue&type=script&lang=ts&"
export * from "./ArticleRelatedHeadlinesList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleRelatedHeadlinesList.vue?vue&type=style&index=0&id=06e2ba25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2ba25",
  null
  
)

export default component.exports